module.exports = __webpack_public_path__ + "static/BIBLIOTECA-acb9035fa247b77a6a7b6cf1510ad591.png";